import React from 'react'
import { Empty as AntEmpty } from 'antd'
import { EmptyProps as AntEmptyProps } from 'antd/lib/empty'

type Props = AntEmptyProps

export const PRESENTED_IMAGE_SIMPLE = AntEmpty.PRESENTED_IMAGE_SIMPLE
export const PRESENTED_IMAGE_DEFAULT = AntEmpty.PRESENTED_IMAGE_DEFAULT

export const Empty: React.FC<Props> = ({
  className,
  description,
  image = PRESENTED_IMAGE_DEFAULT
}) => <AntEmpty className={className} description={description} image={image} />
